(function () {
	'use strict';

	angular
        .module('app')
        .controller('HomeController', HomeController); 

	angular
		.module("app")
		.service("PreferencesState", PreferencesState);

	function PreferencesState(UserService, BrandService, SeasonService) {
		var self = this;

		self.seasonId = 0;
		self.brandId = 0;
		self.showStartupHelp = false;
		self.brands = [];
		self.seasons = [];

		self.getBrands = function() {
			BrandService.getBrandsByUser().then(function(data) {
				self.brands = data;
			});
		};

		self.getSeasons = function () {
			SeasonService.getSeasonsByBrand(self.brandId).then(function (data) {
				self.seasons = data;
			});
		};

		self.setBrand = function(brandId) {
			self.brandId = brandId;
			self.getSeasons();
		};
	}

    function HomeController($scope, $cookies, $location, $state, $rootScope, $window, cfpLoadingBar, ForecastingService, UserService, SeasonService, BrandService, UserPreferenceService, PreferencesState) {
		var model = this;
		model.docInterface = {};
		model.massForecastMetaData = {};
		$scope.setupBrandSeason = false;
        $scope.preferencesState = PreferencesState;
        //console.log("hello", PreferencesState)
        $scope.permissionDenied = function () {
            $state.go('permissionDenied');
        }

        $scope.goToUserPage = function (data) {
            $state.go(data.pageName, data.params);
        }

        $scope.loaderClosed = function () {
            cfpLoadingBar.complete();
        }

        $scope.loaderStart = function () {
            cfpLoadingBar.start();
        }

		//UserService.shouldShowStartupHelp().then(function (data) {
  //          PreferencesState.getBrands();
  //          //console.log("dataaa",data)
		//	if (data) {
		//		$scope.startup = new StartupController(UserPreferenceService, PreferencesState, UserService);
  //              $scope.startup.start();
               
		//	}
		//});

		$scope.$on('$dropletReady', function whenDropletReady() {
			model.docInterface.allowedExtensions(['.xlsx', '.xls']);
			model.docInterface.defineHTTPSuccess([/2.{2}/]);
			model.docInterface.useArray(true);
		});

		$scope.selectDoc = function (e) {
			uploadDoc(e.files[0], 'browse');
		}

		model.addDoc = function (file) {
			uploadDoc(file.file, 'dragdrop');
		}

		function uploadDoc(file, source) {
			model.file = file;
			var ext = model.file.name.substr(model.file.name.lastIndexOf('.') + 1);

			ForecastingService.uploadMassForecastDocument(model.file)
                .then(function (response) {
                	angular.forEach(model.docInterface.getFiles(model.imageInterface.FILE_TYPES.VALID), function (irow) {
                		irow.deleteFile();
                	});
                	model.message = "success";
                }, function (error, status) {
                	model.message = "failure";
                });
		}

	}

	function StartupController(userPreferenceService, preferencesState, userService) {
		var self = this;

		//Add new steps here. 
		//There must be a corresponding div in #startupModal in home.tpl.html.
		self.steps = ["welcome", "profile", "help", "finish"];

		self.preferencesState = preferencesState;
		self.stepIndex = 0;
		self.step = "welcome";
		self.lastStepIndex = self.steps.length - 1;

		self.navigate = function(index) {
			self.stepIndex = index;
			self.step = self.steps[index];
		};

		self.start = function () {
			self.navigate(0);
			self.showUI();
		};

		self.next = function () {
			if (self.stepIndex < self.lastStepIndex) {
				self.navigate(self.stepIndex + 1);
			}
		};

		self.back = function () {
			if (self.stepIndex > 0) {
				self.navigate(self.stepIndex - 1);
			}
		};

		self.end = function () {
			self.navigate(self.lastStepIndex);
		};

		self.cancel = function () {
			self.hideUI();
		};

		self.finish = function() {
			self.saveUserProfile();
			self.hideUI();
		};

		self.canNext = function () {
			return self.stepIndex < self.lastStepIndex;
		};

		self.canBack = function () {
			return self.stepIndex > 0;
		};

		self.canCancel = function () {
			return !self.canFinish();
		};

		self.canFinish = function () {
			return self.stepIndex === self.lastStepIndex;
		};

		self.hideUI = function() {
			$("#startupModal").modal("hide");
		};

		self.showUI = function() {
			$("#startupModal").modal("show");
		};

		self.saveUserProfile = function() {
			if (preferencesState.brandId > 0) {
				userPreferenceService.updateSingleUserPreference(0, "UserBrandId", preferencesState.brandId.toString(), true);

				if (preferencesState.seasonId > 0)
					userPreferenceService.updateSingleUserPreference(0, "UserSeasonId", preferencesState.seasonId.toString(), true);
			}
			userService.setShowStartupHelp(false);
		};
	}
})();
